/**
 * Mapping Definition
 *
 * key = vue2 path name / requested by most of the APIs
 * value = vue3 path name / new schema, used in the frontend and also by the client search
 */
export const defaultMapping = {
  id: 'id',
  salutation_id: 'anredeId',
  commercial_work_percentage: 'anteilTaetigkeitBuero',
  street: 'adresse.strasse',
  street_number: 'adresse.hausnummer',
  zip_code: 'adresse.plz',
  city: 'adresse.ort',
  iban_code: 'bankverbindung.iban',
  swift_code: 'bankverbindung.bic',
  bank_name: 'bankverbindung.bankname',
  personal_status: 'familienstand',
  title: 'titel',
  firstname: 'vorname',
  lastname: 'nachname',
  gender: 'geschlecht',
  birthday: 'geburtsdatum',
  nationality: 'nationalitaet',
  birthname: 'geburtsname',
  placeOfBirth: 'geburtsort',
  countryOfBirth: 'geburtsland',
  jobname: 'beruf',
  berufsgruppe: 'berufsgruppe',
  nonSmoker: 'nichtraucher',
  email: 'email',
  phone: 'telefon',
  cellphone: 'mobil',
  fax: 'fax',
  personalverantwortung: 'personalverantwortung',
  weight: 'gewicht',
  height: 'groesse',
  education: 'hoechsterBildungsabschluss',
  anzahlKinder: 'anzahlKinder',
  fuehrerscheindatum: 'fuehrerscheindatum',
};

export type DefaultMappingKeys = keyof typeof defaultMapping;
